define('views/pages/trade/offer/navbar',['require','jquery','underscore','views/base/view','text!templates/pages/trade/offer/navbar.ejs','models/pages/trade/offer/repeat/index','views/pages/trade/offer/repeat/index','views/filter-list'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        View = require('views/base/view'),
        template = require('text!templates/pages/trade/offer/navbar.ejs'),
        RepeatModalModel = require('models/pages/trade/offer/repeat/index'),
        RepeatModalView = require('views/pages/trade/offer/repeat/index'),
        FilterListView = require('views/filter-list');

    /*
        TRADE OFFER NAVBAR
    */

    var TradeOfferNavbarView = View.extend({
        region: 'trade-offer-navbar',
        className: 'navbar-inner',
        autoRender: true,
        template: template,
        regions: {
            'navbar': '.menu-expand'
        },
        listen: {
            'change:loading model': 'render'
        },
        events: {
            'click .menu-repeat-request': 'repeatRequest',
            'click #om': 'clickOm',
            'click #fo': 'clickFo'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
        },
        clickOm: function(e){
            var state = this.model.get('state');
            if(state === 'om' || $(e.target).hasClass('disabled')){
                e.preventDefault();
            }
            this.destroyTooltip();
            $('body').tooltip({ selector: '#openMarket a', container: 'body', placement: 'bottom' });
        },
        clickFo: function(e){
            var state = this.model.get('state');
            if(state === 'fo' || $(e.target).hasClass('disabled')){
                e.preventDefault();
            }
            this.destroyTooltip();
            $('body').tooltip({ selector: '#openMarket a', container: 'body', placement: 'bottom' });//
        },
        render: function() {
            this.destroyTooltip();

            View.prototype.render.apply(this, arguments);

            this.subview('filter-list', new FilterListView({ model: this.model.filterList }));

            var _this = this;

            $('.search-query', this.$el).on('input propertychange', _.debounce(function() {
                _this.model.set('search', $(this).val());
            }, 200));

            this.$('#openMarket a').tooltip({ container: 'body', placement: 'bottom' });
        },
        destroyTooltip: function() {
            this.$('#openMarket a').tooltip('destroy');
        },
        repeatRequest: function() {
            var model = new RepeatModalModel();
            var view = new RepeatModalView({ model: model });
            this.subview('modal', view);

            // start loading
            model.set('tradeId', this.model.get('tradeId'));

            model.on('action', function(action, cancel) {
                if (action === 'submit') {
                    var selection = model.request.items.where({ selected: true });

                    if (selection.length) {
                        this.publishEvent('repeatRequest', _.map(selection, function(model) {
                            return model.getAttributes();
                        }), cancel);
                    } else {
                        cancel();
                    }

                }
            });
        },
        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        }
    });

    return TradeOfferNavbarView;
});

